import React from 'react';

export default function LoadingChip({ text = "Loading...", style = {}, containerStyle = {} }) {
  return (
    <div className="loading-container" style={containerStyle}>
      <div className="loading-chip" style={style}>
        <span className="spinner"></span>
        <span>{text}</span>
      </div>
    </div>
  );
}
